import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import ReportedMessage from "./content/pages/private/Reported/ReportedMessage";
import ReportedMessageDetails from "./content/pages/private/Reported/ReportedMessageDetails";
// import UserForm from "./content/pages/private/Users/UserForm";
// import SnippetForm from "./content/pages/private/Snippets/SnippetForm";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages
const Transactions = Loader(
  lazy(() => import('src/content/applications/Transactions'))
);

const CpCheck = Loader(
  lazy(() => import('src/content/pages/Components/Forms'))
);

// Snippets

const Snippets = Loader(
  lazy(() => import('src/content/pages/private/Snippets/Snippets'))
);

const SnippetForm = Loader(
  lazy(() => import('src/content/pages/private/Snippets/SnippetForm'))
);

const Users = Loader(
  lazy(() => import('src/content/pages/private/Users/Users'))
);

const UserForm = Loader(
  lazy(() => import('src/content/pages/private/Users/UserForm'))
);
const ChangePassword = Loader(
  lazy(() => import('src/content/pages/private/Profile/ChangePassword'))
);

const Faqs = Loader(lazy(() => import('src/content/pages/private/Faqs/Faqs')));

const FaqForm = Loader(
  lazy(() => import('src/content/pages/private/Faqs/FaqForm'))
);

const ReportedContent = Loader(
  lazy(
    () => import('src/content/pages/private/Reported/ReportedContent')
  )
);
const ReportedContentDetails = Loader(
  lazy(
    () =>
      import('src/content/pages/private/Reported/ReportedContentDetails')
  )
);

const Categories = Loader(
  lazy(() => import('src/content/pages/private/Categories/Categories'))
);
const CategoryDetails = Loader(
  lazy(() => import('src/content/pages/private/Categories/CategoryDetails'))
);

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

// Public

const Login = Loader(lazy(() => import('src/content/pages/Public/Login')));

interface IRouteObject extends RouteObject {
  icon?: string;
  name?: string;
  showInSidebar?: boolean;
  children?: IRouteObject[];
}

const routes: IRouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="login" replace />
      },
      {
        path: '/',
        element: <Navigate to="login" replace />
      },
      {
        path: 'login',
        element: <Login />
      },
      //   {
      //     path: 'overview',
      //     element: <Navigate to="/login" replace />
      //   },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'profile',
    element: <SidebarLayout />,
    children: [
      {
        path: 'change-password',
        element: <ChangePassword />
      }
    ]
  },
  {
    path: 'dashboard',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="users" replace />
      },
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'users/:id',
        element: <UserForm />
      },
      {
        path: 'snippets',
        element: <Snippets />
      },
      {
        path: 'snippets/:id',
        element: <SnippetForm />
      },
      {
        path: 'faqs',
        element: <Faqs />
      },
      {
        path: 'faqs/:id',
        element: <FaqForm />
      },
      {
        path: 'reported',
        // element: <Navigate to="contents" />,
        children: [
            {
                path: 'contents',
                element: <ReportedContent />
              },
              {
                path: 'contents/:id',
                element: <ReportedContentDetails />
              },
              {
                path: 'messages',
                element: <ReportedMessage />
              },
              {
                path: 'messages/:id',
                element: <ReportedMessageDetails />
              },
        ]
      },
    //   {
    //     path: 'reported-content/:id',
    //     element: <ReportedContentDetails />
    //   },
      {
        path: 'categories',
        element: <Categories />
      },
      {
        path: 'categories/:id',
        element: <CategoryDetails />
      },
      {
        path: 'transactions',
        element: <Transactions />
      },
      {
        path: 'cp-check',
        element: <CpCheck />
      }
    ]
  }
];

export default routes;
